import React, { useEffect, useState } from 'react';
import { Accordion, AccordionItemInterface, Button, DatePicker, DateRange, Group, MomentObj, SelectOption } from '@veneer/core';
import ModalScreen from './ModalScreen';
import SelectWrapper from './selectWrapper';
import { useTranslation } from 'react-i18next';
import moment, { Moment } from 'moment';
import { IValuesSelector } from './activationAssignationLogic';
import { onClearFormat } from './activationAssignationScreen';

interface Props {
    editMassStartDate: string | Moment | undefined;
    editMassEndDate: string | Moment | undefined;
    handleCloseModal?: () => void;
    handleEditMassStartDate?: () => void;
    handleEditMassEndDate?: () => void;
    optionsSubReatil: SelectOption[];
    optionPos: SelectOption[];
    filterOptions: (value: string, type: onClearFormat) => void;
    onchangeSubRetail: (value: IValuesSelector) => void;
    onclickPos: () => void;
    onchangePos: (value: IValuesSelector) => void;
    subRetailID: number[],
    posCodeID: number[],
    accordionData: any[],
    setAccordionData: (value: any[]) => void;
    handleCreateActivationBySubRetail: () => void;
    handleCreateActivationByPos: () => void;
    onClear: (value: onClearFormat) => void;
}
export const CreateActivationAssignation = ({
    editMassStartDate, editMassEndDate, optionsSubReatil,
    subRetailID, optionPos, posCodeID, accordionData,
    handleCloseModal, handleEditMassStartDate,
    handleEditMassEndDate, filterOptions,
    onchangeSubRetail, handleCreateActivationBySubRetail,
    handleCreateActivationByPos, onclickPos,
    onchangePos, onClear, setAccordionData
}: Props) => {
    const [t] = useTranslation("global");
    const [programBySubretail, setProgramBySuretail] = useState(false);
    const [programByPOS, setProgramByPOS] = useState(false);
    const [nextProgrammingbyPOS, setNextProgrammingbyPOS] = useState(false);

    const handleEditStartDate = (date: MomentObj | DateRange | undefined, posCode: string) => {
        if (!date) return;

        const updatedData = accordionData.map(item => {
            if (item.posCode.toString() === posCode.toString()) {
                const newStartDate = date;
                const newEndDate = item.endDate && item.endDate.isBefore(newStartDate)
                    ? newStartDate
                    : item.endDate;

                return {
                    ...item,
                    startDate: newStartDate,
                    endDate: newEndDate,
                    expanded: true,
                };
            }
            return { ...item, expanded: false };
        });

        setAccordionData(updatedData);
    };

    const handleEditEndDate = (date: MomentObj | DateRange | undefined, posCode: string) => {
        if (!date) return;

        const updatedData = accordionData.map(item => {
            if (item.posCode.toString() === posCode.toString()) {
                return { ...item, endDate: date, expanded: true };
            }
            return { ...item, expanded: false };
        });

        setAccordionData(updatedData);
    };

    const handleExpand = (event: any, index: number, item: any) => {
        const updatedData = data.map((item, idx) => ({
            ...item,
            expanded: idx === index
        }));

        setData(updatedData);
    };

    const handleCollapse = (event: any, index: number, item: any) => {
        const updatedData = [...data];
        updatedData[index].expanded = false;
        setData(updatedData);
    };

    const [data, setData] = useState<AccordionItemInterface[]>([])

    useEffect(() => {
        if (accordionData.length > 0) {

            setData(
                accordionData.map((item) => ({
                    id: item.id,
                    header: {
                        centralArea: item.posName,
                        previewArea: item.posCode,
                    },
                    expanded: item.expanded,
                    content: (
                        <div className="customDatePickerMain">
                            <div>
                                <DatePicker
                                    className="customDatePicker"
                                    blockPastDates
                                    calendarOrientation={["left", "down"]}
                                    label="Start Date"
                                    onChange={(date) => handleEditStartDate(date, item.posCode)}
                                    orientation="horizontal"
                                    value={item.startDate}
                                    format="LL"
                                    clearIcon={false}
                                />
                            </div>
                            <div>
                                <DatePicker
                                    className="customDatePicker"
                                    clearIcon={false}
                                    calendarOrientation={["left", "down"]}
                                    label="End Date"
                                    onChange={(date) => handleEditEndDate(date, item.posCode)}
                                    orientation="horizontal"
                                    value={item.endDate}
                                    format="LL"
                                    disabled={!item.startDate}
                                    isOutsideRange={(day) => isEndDateOutsideRange(day, moment(item.startDate))}
                                />
                            </div>
                        </div>
                    ),
                })))
        }
    }, [accordionData])

    const isEndDateOutsideRange = (day: MomentObj, startDateStr: Moment) => {
        return startDateStr ? day.isBefore(startDateStr, "day") : false;
    };

    const isEndDateOutsideRangeEditMass = (day: MomentObj) => {
        return editMassStartDate ? day.isBefore(editMassStartDate, "day") : false;
    };

    const enableAccordionNext = accordionData.length > 0 ? subRetailID.every(subRetail => accordionData.some(item => item.subRetailId === subRetail)) : false;
    const enableAccordionToAdd = accordionData.length > 0 ? accordionData.every(item => item.startDate !== '' && item.endDate !== '') : false;

    return (
        <div>
            {(!programBySubretail && !programByPOS && !nextProgrammingbyPOS) && (<ModalScreen
                show
                title={t("modal.programmingQuestion")}
                onClose={handleCloseModal}
                footer={<div className="footerModal">
                    <Group>
                        <Button onClick={() => setProgramBySuretail(true)}>
                            {t("modal.massProgramming")}
                        </Button>
                        <div style={{ marginLeft: "30px" }}>
                            <Button onClick={() => setProgramByPOS(true)}>
                                {t("modal.individualProgramming")}
                            </Button>
                        </div>
                    </Group></div>} />
            )}
            {programBySubretail && (
                <ModalScreen
                    show
                    title={t("modal.massProgramming")}
                    onClose={handleCloseModal}
                    footer={<div className="footerModal">
                        <Group>
                            <Button onClick={() => setProgramBySuretail(false)}>
                                {t("header.back")}
                            </Button>
                            <div style={{ marginLeft: "50px" }}>
                                <Button
                                    appearance="secondary"
                                    disabled={(editMassStartDate !== undefined && editMassEndDate !== undefined && subRetailID.length > 0) ? false : true}
                                    onClick={handleCreateActivationBySubRetail}
                                >
                                    {t("header.addSchedule")}
                                </Button>
                            </div>
                        </Group></div>}
                >
                    <div className="modalContentWrapper">
                        <div className="customDatePickerMain">
                            <div>
                                <div className='customDatePicker'>
                                    <SelectWrapper
                                        options={optionsSubReatil}
                                        onChange={onchangeSubRetail}
                                        onClear={() => onClear('subRetailID')}
                                        value={subRetailID}
                                        disabled={false}
                                        label={t("header.subRetail")}
                                        showSearch={true}
                                        onSearch={(e: string) => filterOptions(e, 'subRetailID')}
                                        multiple
                                    />
                                </div>
                                <DatePicker
                                    className="customDatePicker"
                                    blockPastDates
                                    calendarOrientation={["left", "down"]}
                                    label="Start Date"
                                    onChange={handleEditMassStartDate}
                                    orientation="horizontal"
                                    value={editMassStartDate}
                                    format="LL"
                                    clearIcon={false}
                                />
                            </div>
                            <div>
                                <DatePicker
                                    className="customDatePicker"
                                    clearIcon={false}
                                    calendarOrientation={["left", "down"]}
                                    label="End Date"
                                    onChange={handleEditMassEndDate}
                                    orientation="horizontal"
                                    value={editMassEndDate}
                                    format="LL"
                                    disabled={false}
                                    isOutsideRange={isEndDateOutsideRangeEditMass}
                                />
                            </div>
                        </div>
                    </div>
                </ModalScreen>
            )}
            {programByPOS && (<ModalScreen
                show
                title={t("modal.individualProgramming")}
                onClose={handleCloseModal}
                footer={<div className="footerModal">
                    <Group>
                        <Button onClick={() => {
                            setProgramBySuretail(false);
                            setProgramByPOS(false);
                            setNextProgrammingbyPOS(false)
                        }}>
                            {t("header.back")}
                        </Button>
                        <div style={{ marginLeft: "50px" }}>
                            <Button appearance="secondary"
                                disabled={!enableAccordionNext}
                                onClick={() => setNextProgrammingbyPOS(true)}>
                                {t("header.next")}
                            </Button>
                        </div>
                    </Group></div>}
            >
                <div className="modalContentWrapper">
                    <p className="descriptionModal">{t("modal.messageToSelectSubRetail")}</p>
                    <div className="customDatePickerMain">
                        <div className='customDatePicker'>
                            <SelectWrapper
                                options={optionsSubReatil}
                                onChange={onchangeSubRetail}
                                onClear={() => onClear('subRetailID')}
                                value={subRetailID}
                                disabled={false}
                                label={t("header.subRetail")}
                                showSearch={true}
                                onClose={onclickPos}
                                onSearch={(e: string) => filterOptions(e, 'subRetailID')}
                                multiple
                            />
                        </div>
                        <div className='customDatePicker'>
                            <SelectWrapper
                                options={optionPos}
                                onChange={onchangePos}
                                onClear={() => onClear('posCodeID')}
                                value={posCodeID}
                                disabled={subRetailID.length > 0 ? false : true}
                                onOpen={() => { }}
                                onSearch={(e: string) => filterOptions(e, 'posCodeID')}
                                showSearch={true}
                                label={t("header.pointOfSale")}
                            />
                        </div>
                    </div>
                </div>
            </ModalScreen>)}
            {nextProgrammingbyPOS && (<ModalScreen
                show
                title={t("modal.individualProgramming")}
                onClose={handleCloseModal}
                footer={<div className="footerModal">
                    <Group>
                        <Button onClick={() => {
                            setProgramBySuretail(false);
                            setProgramByPOS(true);
                            setNextProgrammingbyPOS(false)
                        }}>
                            {t("header.back")}
                        </Button>
                        <div style={{ marginLeft: "50px" }}>
                            <Button appearance="secondary"
                                disabled={!enableAccordionToAdd}
                                onClick={handleCreateActivationByPos}
                            >
                                {t("header.addSchedule")}
                            </Button>
                        </div>
                    </Group></div>}
            >
                <div>
                    {data.length > 0 && (
                        <Accordion
                            appearance="outlined"
                            items={data}
                            onCollapse={handleCollapse}
                            onExpand={handleExpand}
                        />
                    )}
                </div>
            </ModalScreen>)}
        </div>
    );
};

export default CreateActivationAssignation;
